import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1300px;
  display: flex;
  overflow-x: auto;

  flex-direction: column;

  .view {
    width: 100%;
    max-width: 1300px;
    padding: 20px;
    flex: 1;
  }

  h1 {
    flex: 1;
    text-align: left;
    color: #000;
  }

  @media (max-width: 750px) {
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }

  .filters-row {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 20px;
    background: #fff;
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
    align-items: flex-end;
    width: 100%;
  }
`;

export const List = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  padding: 40px 0;

  div {
    background: #fff;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    border-radius: 12px;
    margin: 10px;
    border: 1px solid #f0f0f0;
    transition: all 0.2s ease;

    &:hover {
      border-color: #008037;
    }

    .infos {
      display: flex;
      width: 100%;
      margin: 0;
      border: none;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 10px 15px;
    }

    img {
      width: 100%;
      height: 200px;
      object-fit: cover;
      border-width: 1px 0;
      border-color: #f0f0f0;
      border-style: solid;
    }

    p {
      font-size: 16px;
      text-align: left;
      color: #333;
      font-weight: 600;
    }

    span {
      font-size: 13px;
      color: #666;
    }

    .actions {
      display: flex;
      margin: 5px 0 10px 0;
      width: 100%;
      justify-content: center;
      gap: 10px;
      border: none;
    }
  }
`;

export const ViewFilter = styled.div`
  display: flex;
  width: 100%;
  border: none;
  justify-content: space-between;
  font-size: 16px;
`;

export const InputFilter = styled.input`
  padding: 8px;
  border-radius: 5px;
  background-color: #f0f0f0;
  color: #000c;
  height: 40px;
  width: 100%;
  max-width: 450px;
  border: none;
  font-size: 16px;
`;

export const Label = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  display: inline-block;
  background: ${(props) => props.color};
`;
